import Backbone from 'backbone'
import $ from 'jquery'
import i18n from 'scoreboard/components/i18n'

const ChooseCannedReportStep = Backbone.View.extend({

	// this.model is a ReportWizardInfo object

	className: 'panel panel-with-table report-types',

	events: {
		'click td.report-type' : 'select'
	},

	/**
	 * @constructs Shows a list of canned reports to choose from
	 *
	 * @param {Object} options.template the template to use
	 * @param {Object} options.reportTypes a hash of report types and their
	 * wizard paths
	 */
	initialize: function(options = {}) {
		this.options = options
	},

	render: function() {
		this.$el.html(this.options.template(this.context(this.options.reportTypes)))
		let type = this.model.get('reportType')
		if (type && this.options.reportTypes[type]) {
			this.$('td[data-type='+type+']').toggleClass('is-selected', true)
			this._applyType(type)
		}
		return this
	},

	context(reportTypes) {
		let context = []
		for (let rt in reportTypes) {
			context.push({
				dataType: rt,
				icon: reportTypes[rt].icon,
				label: i18n.get(reportTypes[rt].key)
			})
		}
		return { reportTypes: context }
	},

	select: function(e) {
		this.$('td.report-type').removeClass('is-selected')

		//update the path based on which report is selected
		let type = $(e.currentTarget).addClass('is-selected').data('type')
		this._applyType(type)
	},

	_applyType: function(type) {
		let path = this.options.reportTypes[type]
		this.model.set('reportType', type)
		this.model.path(path)
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
	}
})

export default ChooseCannedReportStep
ChooseCannedReportStep.__filename__ = 'reports/wizard/choose-report/choose-canned-report-step.js'
